import { SATELLITES } from './config';

function normalizeHost(raw: string): string {
  return raw.replace(/^www\./i, '').trim().toLowerCase();
}

function isPrerenderHost(hostname: string): boolean {
  const host = normalizeHost(hostname);
  return (
    host === 'localhost' ||
    host === '127.0.0.1' ||
    host === '::1' ||
    host === '[::1]'
  );
}

export function detectSatelliteApex(): string | null {
  if (typeof window === 'undefined') {
    return null;
  }
  const actualHost = normalizeHost(window.location.hostname);
  const spoof = isPrerenderHost(actualHost)
    ? new URLSearchParams(window.location.search).get('__prerenderHost')
    : null;
  const spoofedHost = spoof ? normalizeHost(spoof) : null;
  if (spoofedHost && SATELLITES[spoofedHost]) {
    return spoofedHost;
  }
  return SATELLITES[actualHost] ? actualHost : null;
}

export function currentSatellitePath(): string {
  if (typeof window === 'undefined') {
    return '/';
  }
  const raw = window.location.pathname.trim() || '/';
  if (raw.length > 1 && raw.endsWith('/')) {
    return raw.slice(0, -1);
  }
  return raw;
}
